export const required = value => (value || typeof value === 'number' ? undefined : gettext('Обязательное поле'))

export const string = value =>
  value && !/^[а-яА-Яa-zA-Z -]+$/gi.test(value)
  ? gettext('Неверный формат значения. В этом поле разрешено использовать только буквы, пробел и тире.')
  : undefined

export const dateFormat = value =>
  value && !/^(0[1-9]|[12][0-9]|3[01])[/.](0[1-9]|1[012])[/.](19|20)\d\d$/g.test(value)
  ? gettext('Неверный формат значения')
  : undefined

export const dateCardExpireFormat = value =>
  value && !/^(0[1-9]|1[012])[/](2|3)\d$/g.test(value)
  ? gettext('Неверный формат значения')
  : undefined

export const maxLength = max => value =>
  value && value.length > max ? gettext('Вы привысили допустимое количество вариантов') : undefined
export const maxLength3 = maxLength(3)
export const maxLength10 = maxLength(10)

export const minLength = min => value =>
  value && value.length < min ? gettext('Количество выбранных вариантов должно быть больше') + ' ' + min : undefined
export const minLength1 = minLength(1)

export const number = value => value && isNaN(value) ? gettext('Числовое поле') : undefined
export const positiveNumber = value => Number(value) < 0 ? gettext('Значение должно быть положительное') : undefined
export const integerNumber = value => !Number.isInteger(Number(value)) ? gettext('Значение должно быть целочисленным') : undefined

export const minValue = min => value =>
  value && value < min ? `Must be at least ${min}` : undefined
export const minValue1 = minValue(1)

export const mustBeSelected = value =>
  parseInt(value) === 0 ? gettext('Выберите один из предложенных вариантов') : undefined

export const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
  ? gettext('Неверный email адрес')
  : undefined

export const slug = value =>
  value && !/^[a-zA-Z0-9._-]+$/gi.test(value) ? gettext('Неверный формат адрес страницы') : undefined

export const alphaNumeric = value =>
  value && /[^a-zA-Z0-9 ]/i.test(value)
    ? 'Only alphanumeric characters'
    : undefined

export const phoneNumber = value =>
  value && !/^(0|[1-9][0-9]{10})$/i.test(value)
    ? gettext('Неверный номер телефона, должно быть 11 цифр')
    : undefined

// export const phoneFormat = value =>
//   //+1 333 555 77 99
//   value && !/^(\+)(\d{1,4})( )(\d{3})( )(\d{3})( )(\d{2})( )(\d{2})$/g.test(value)
//   ? gettext('Неверный формат телефона')
//   : undefined

export const url = value => {
  return value && !/^(?:http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/i.test(value)
    ? gettext('Неверный url адрес')
    : undefined
}

export const youtubeUrl = value => {
  return value && !/^(http(s)?:\/\/)?((w){3}.)?youtu(be|.be)?(\.com)?\/.+/i.test(value)
    ? gettext('Разрешается добавлять ссылки только на youtube')
    : undefined
}

export const image = value => {
  return value && !/^([а-яА-Я\w-.() ])*\.(?:jpg|jpeg|gif|png|tiff|webp)$/i.test(value)
    ? gettext('Неверный формат изображения')
    : undefined
}

const imageSize = max => value =>
  value && value > max ? gettext(`Размер загружаемого файла должен быть меньше ${max} МБ`): undefined
export const imageSize5 = imageSize(5)
